export function isArray(value): boolean {
    return Array.isArray(value);
}
